<template lang="pug">
  .map
     svg(width="100%"  viewBox="0 0 83 120" fill="none" xmlns="http://www.w3.org/2000/svg")
      defs
        path(id="mapMark" d="M28.2 0c-5 .1-9 4.3-8.9 9.2 0 1.8.3 3.5.8 5.1 1 3.2 3.4 8.2 8.6 12.7 5-4.7 7.2-9.7 8-13 .6-1.7.8-3.4.7-5.1 0-5-4.2-9-9.2-8.9zm.3 12.3a4 4 0 0 1-4.2-4 4 4 0 0 1 4-4.1 4 4 0 0 1 4.2 4 4 4 0 0 1-4 4.1z" fill="#F8B037")
      g(:transform="`translate(${zoomP[currSceneIdx][0]*zoomF} ${zoomP[currSceneIdx][1]*zoomF}) scale(${1+1*zoomF})`")
        path(ref="frame" :stroke-dashoffset="318-318*t0" stroke-dasharray="318" stroke="#fff" stroke-width="2" d="M34.7 21H.7c-2 2 1.2 1.3 1.2 3.8S-.5 29 .7 29.7c1.2.7 3.7 2 1.2 5.3C-.7 38.3.7 38.7.7 39.9c0 1.1 5.7 4 3.7 6.8s1.6 2.6 1 4.4c-.5 1.7 1.4 3 4.2 6 2.8 3-.5 5.6 1.5 5.6s3.4 2 3.3 3.5c-.1 1.6 2.3 6.8 4.7 7.1 2.4.4 1 2 0 4s3 3.7 3 5.3c.2 1.6 2.6 3.5 5.8 4 3.2.6-1.5 2.3-1.9 4.3-.4 2 1.9.4 3.5 0s.8-1.9 1.3 2.6c.6 4.5 2.6 4.6 6.6 4.6 4 0 2.8 3 4.8 3.6 2 .7 5.2-1 5.3 1.2.2 2 1 2.6 3 2.6s6.2 2.4 6.2 4.8c0 2.3-3 4 0 4s-.4 1.8 2 2.6 17.8-2 20-2.7c2-.6 2.6-.1 1-1.2-1.6-1-2.8-4.2-1-4.2 1.7 0 0-3.3 1-6 1-2.6 3.9-2.8 3.2-3.5-.7-.6-2-.4-1.6-1.2.4-.8-.5-2-1.6-2.7-.9-.6-1-2.2-1-3l-44-40V21z")
      g
        circle(cx="39" cy="68" :r="2*t01" fill="#F8B037" :transform="`translate(${(zoomP[currSceneIdx][0]+39)*zoomF} ${(zoomP[currSceneIdx][1]+68)*zoomF})`")
        circle(cx="10" cy="30" :r="2*t01" fill="#F8B037" :transform="`translate(${(zoomP[currSceneIdx][0]+10)*zoomF} ${(zoomP[currSceneIdx][1]+30)*zoomF})`")
        circle(cx="23" cy="78" :r="2*t01" fill="#F8B037" :transform="`translate(${(zoomP[currSceneIdx][0]+23)*zoomF} ${(zoomP[currSceneIdx][1]+78)*zoomF})`")
        circle(cx="63" cy="111" :r="2*t01" fill="#F8B037" :transform="`translate(${(zoomP[currSceneIdx][0]+63)*zoomF} ${(zoomP[currSceneIdx][1]+111)*zoomF})`")
        circle(cx="36" cy="94" :r="2*t01" fill="#F8B037" :transform="`translate(${(zoomP[currSceneIdx][0]+36)*zoomF} ${(zoomP[currSceneIdx][1]+94)*zoomF})`")
        use(v-for="(p,i) in poss"  xlink:href="#mapMark" :transform="`translate(${p[0]+28.36*t[`t${i+1}`]+(zoomP[currSceneIdx][0]+p[0]+28.36)*zoomF}, ${p[1]+27*t[`t${i+1}`]+(zoomP[currSceneIdx][1]+p[1]+27)*zoomF}) scale(${1-t[`t${i+1}`]})`")
        //g(:transform="`translate(${tx}, ${ty})`")
          path(d="M28.2 0c-5 .1-9 4.3-8.9 9.2 0 1.8.3 3.5.8 5.1 1 3.2 3.4 8.2 8.6 12.7 5-4.7 7.2-9.7 8-13 .6-1.7.8-3.4.7-5.1 0-5-4.2-9-9.2-8.9zm.3 12.3a4 4 0 0 1-4.2-4 4 4 0 0 1 4-4.1 4 4 0 0 1 4.2 4 4 4 0 0 1-4 4.1z" fill="#F8B037")
      //circle(cx="40" cy="69" :r="2" fill="#f80020")

</template>
<script>
import * as THREE from 'three'
import {mapState, mapMutations} from 'vuex'
import {TweenMax, TimelineMax, Power3} from 'gsap'
import Raf from 'src/helpers/Raf'
//import Component from '@/components/Component'

export default {
  name: "Map",
  props: {
    prop: {
      default: false,
      required: false
    }
  },
  components: {
    //Component
  },
  data() {
    return {
      curPos: [0,0],
      tarPos: [0,0],
      p:0,
      idx:0,
      pos:[
        [39, 68],
        [10, 30],
        [23, 78],
        [63, 111],
        [36, 94]
      ],
      poss: [
        [11, 38],
        [-19, 0],
        [7.5, 64],
        [-6, 47],
        [34, 81]
      ],
      t0: 0,
      t01: 0,
      t:{
        t1: 1,
        t2: 1,
        t3: 1,
        t4: 1,
        t5: 1,
      },
      lastIdx: 0,
      zoomF: 0,

      zoomP: [
        [-38, -66],
        [20, 10],
        [-32, -118],
        [-6, -86],
        [-86, -152]
      ],
      zoomP0: [
        [1, 1],
        [30, 39],
        [4, -25],
        [17, -9],
        [-23, -42]
      ],
    }
  },
  computed:{
    ...mapState('app', ['mapProgress', 'currSceneIdx']),
    tx(){
      return Number.parseFloat(this.curPos[0].toFixed(1))
    },
    ty(){
      return Number.parseFloat(this.curPos[1].toFixed(1))
    }
  },
  methods: {

    init() {},
    animate() {},
    dis(x, y){
      return Math.sqrt(x*x +y*y)
    },
    update(){




      //let dx = this.tarPos[0] - this.curPos[0]
      //let dy = this.tarPos[1] - this.curPos[1]
      //this.curPos[0] += dx*this.p
      //this.curPos[1] += dy*this.p
      //console.log(999, this.curPos[0].toFixed(1), this.curPos[1].toFixed(1))
    },
    zoomIn(){
      let tl = new TimelineMax({ onComplete: () => {
        }
      })
      this.tl = tl
      tl.add('start')
        .to(
          this,
          1,
          {
            zoomF: 1,
            ease: Power2.easeOut
          },
          `start+=0`
        )
        .to(
          this.$el,
          1,
          {
            opacity: 0,
            ease: Power2.easeOut
          },
          `start+=0.5`
        )
    }
  },
  mounted() {
    window.Map = this
    this.init()
    this.animate()
    //Raf.add(this.update)
    // let dx = []
    // let dy = []
    // let dr = []
    // let dR = []
    // let R = 0
    // dR.push(R)
    // for (let i=0; i<this.poss.length-1; i++){
    //   dx.push(this.poss[i][0] - this.poss[i+1][0])
    //   dy.push(this.poss[i][1] - this.poss[i+1][1])
    //   let r = this.dis(dx[i], dy[i])
    //   R += r
    //   dr.push(r)
    //   dR.push(R)
    // }
    // dx.push(this.poss[this.poss.length-1][0] - this.poss[0][0])
    // dy.push(this.poss[this.poss.length-1][1] - this.poss[0][1])
    // let r = this.dis(dx[this.poss.length-1], dy[this.poss.length-1])
    // R += r
    // dr.push(r)
    // dR.push(R)

    //console.log(505, dx, dy, dr, R)
    //this.curPos = this.poss[this.currSceneIdx]

    let tl = new TimelineMax({ onComplete: () => {
      }
    })
    this.tl = tl
    tl.add('start')
      .to(
        this,
        1,
        {
          t0: 1,
          ease: Power2.easeInOut
        },
        `start+=0`
      )
      .to(
        this,
        0.5,
        {
          t01: 1,
          ease: Power2.easeInOut
        },
        `start+=1`
      )
      .to(
        this.t,
        0.7,
        {
          [`t1`]: 0,
          ease: Power2.easeOut
        },
        `start+=1`
      )

    //console.log(this.$refs.test.getBBox().x+this.$refs.test.getBBox().width/2, this.$refs.test.getBBox().y+this.$refs.test.getBBox().height)
    //console.log(this.$refs.frame.getTotalLength())
  },
  beforeDestroy(){
    //Raf.remove(this.update)
  },
  watch: {
    currSceneIdx(val){
      //this.curPos = this.poss[val]

      let tl = new TimelineMax({ onComplete: () => {
        }
      })
      this.tl = tl
      tl.add('start')
        .to(
          this.t,
          0.7,
          {
            [`t${this.lastIdx+1}`]: 1,
            ease: Power2.easeOut
          },
          `start+=0`
        )
        .to(
          this.t,
          0.7,
          {
            [`t${val+1}`]: 0,
            ease: Power2.easeOut
          },
          `start+=0.2`
        )

      this.lastIdx = val
      //console.log(89898989, val)
    },
    // mapProgress(value){
    //   if (value >= 0) {
    //     let val = value*4.0
    //     let idx = Math.floor(val)
    //
    //     this.idx = idx
    //     this.p = val - idx
    //     this.tarPos = this.poss[this.idx+1]
    //     this.curPos = this.poss[this.idx]
    //   }
    //
    //
    // }
  }
}
</script>


<style lang="sass" scoped>
  @import "src/styles/common.sass"
  .map
    //position: absolute
    //bottom: $ui-margin-top + 1.6rem
    //left: $ui-margin-left+0.2rem
    width: 0.8rem

    //background: #3a54a2




</style>